import $ from 'jquery';
import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faTimes, faCube, faPlus, faMinus, faFolder,faUser,faEnvelope,faAngleDoubleRight , faAngleDoubleLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch, faTimes, faClock, faCube, faPlus, faMinus, faFolder,faUser,faEnvelope,faAngleDoubleRight , faAngleDoubleLeft, faChevronRight);
dom.watch();

import "../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";

$(function () {
    $('.js-multidate').datepicker({
        multidate: true,
        format: 'yyyy年mm月dd日',
        locale: 'ja'
    });
});


    $(function () {
    if ($('#js-unx-header').length) {
        $(window).on('scroll', function () {
            // サイドメニュー表示中は除外
            if ($('body').hasClass('l-sidemenu-active')) return;

            // ヘッダーを固定する
            if ($(this).scrollTop() > 300) {
                $('#js-unx-header').addClass('is-header-fixed');

                // グローバルナビゲーション PC レスポンシブOFF+固定ヘッダー
                // 横スクロールでposition:fixedの要素も横スクロールさせる
                if ($('body:not(.is-responsive)').length) {
                    $('#js-unx-header .l-header__bar, .p-megamenu').css('left', $(this).scrollLeft() * -1);
                }
            } else {
                $('#js-unx-header').removeClass('is-header-fixed');
                if ($('body:not(.is-responsive)').length) {
                    $('#js-unx-header .l-header__bar, .p-megamenu').css('left', 0);
                }
            }
        });
    }
    if ($('#js-unx-menu-button').length) {

        $('#js-unx-menu-button').click(function () {
            if ($('#js-unx-header').width() <= 1200) {
                $(this).toggleClass('is-active');
                $('#js-unx-global-nav').slideToggle(500);
            }
            return false;
        });
    }
    if ($('#js-unx-global-nav .menu-item-has-children > a span').length) {

        $('#js-unx-global-nav .menu-item-has-children > a span').click(function () {
            if ($('#js-unx-header').width() <= 1200) {
                $(this).toggleClass('is-active');
                $(this).closest('.menu-item-has-children').toggleClass('is-active').find('> .sub-menu').slideToggle(300);
            }
            return false;
        });
    }

    if ($('#js-unx-header #js-unx-search-button').length) {

        $('#js-unx-header #js-unx-search-button').click(function () {
            if ($('#js-unx-header').width() > 1200) {
                $(this).closest('#js-unx-header').toggleClass('is-header-search-active');
            }
            return false;
        });
    }
    if ($('.h-drawer_toggle').length) {
        var scrollTop = $(window).scrollTop();
        $('.h-drawer_toggle').on('click', function () {
            $(this).toggleClass('open');
            $('.h-drawer-menu').toggleClass('open');
            $("html,body").toggleClass('drawer_open');

        });
    }

    if ($('#js-modal').length) {
        var modal = $('#js-modal'),
            modalContent = $('#js-modal_content'),
            btnOpen = $("#js-btn_open"),
            btnClose = $("#js-btn_close");
        let html = $(html);

        $(btnOpen).on('click', function () {
            modal.show();
        });

        $(modal).on('click', function (event) {
            if (!($(event.target).closest(modalContent).length) || ($(event.target).closest(btnClose).length)) {
                modal.hide();
            }
        });
    }


    if ($(".js-accordion_btn").length) {
        $(".js-accordion_btn").on("click", function (el) {
            let parentLi = $(el.target).closest(".js-accordion_parent");
            parentLi.toggleClass("is-open");
        });
    }

    if ($('.js-menu-button').length) {
        $(".js-menu-button").on("click", function (el) {
            $(".js-menu-button").toggleClass("is-open");
            $('#js-mc_modal').toggleClass("is-open");
            $("body").toggleClass("is-noscroll")
        });
        $(".m-modal_menu .m-service_menu .menu-item a").on("click", function (el) {
            $(".js-menu-button").toggleClass("is-open");
            $('#js-mc_modal').toggleClass("is-open");
            $("body").toggleClass("is-noscroll")
        });
    }
    if ($('#js-header').length) {
        let height = $('#js-header').height();
        let $targetFixed = $('.js-target-fixed');
        $(window).on('scroll', function () {
            let scroll = $(this).scrollTop();
            if (scroll >= height) {
                if ($targetFixed.length && !($targetFixed.hasClass("is-fixid"))) {
                    $targetFixed.addClass("is-fixid")

                }
            } else {
                if ($targetFixed.length && $targetFixed.hasClass("is-fixid")) {
                    $targetFixed.removeClass("is-fixid")
                }
            }
        });
    }
    });